import React from "react";
import cn from 'classnames'

const text = `老公生日快樂>8< 恭喜老公終於收集所有的小風小馬飛飛飛道具。老公的陪伴就像小風小馬晚安圖一樣，每次都讓小馬好安心好喜歡好可愛哦，所以希望用小風小馬圖讓老公感受到小馬的開心。這次做小風飛飛飛的遊戲，花了一個月左右做的，希望老公喜歡。

老公對不起這大概是最少驚喜的生日慶生，也是最忙碌的慶生，但可以跟老公一起籌備小風小馬房，我覺得很幸福>8< 雖然有時候會有意見不一樣的地方，很謝謝老公總是接納小馬，老公有不同的想法也一定要讓小馬知道，不要委屈，委屈就沒有意義了喔！

今年是跟老公在一起第十年，登記第一年，有了房子之後就跟表示小風和小馬彼此要跟多進一步了，小風小馬房的屋主是小風和小馬一起，老公也要很有自信的管理小風小馬房！希望可以和老公一起實現不同的夢想，創造更多回憶>8<

知道老公和小風媽出櫃之後，一方面很緊張，但另一方面小馬也好開心哦，默默想像我們真的可以辦婚禮的樣子了。也很感謝上帝，小風和小風媽有成功度過最困難的前幾天，希望上帝能繼續祝福小風和小風媽，相信小風媽在我們的陪伴下，一樣會好好的。

小馬也默默地跟上帝說，也許婚禮可以暫定兩年後，我知道還要看小風媽能不能接受，還要看上帝怎麼想，還要看小馬媽怎麼說。如果可以，婚禮也會是小風小馬可以在婚禮上真正交換戒指的那天。接下來的日子，小馬會繼續努力，讓小風媽可以接納小馬。

小馬也決定要更用心陪伴小馬媽。希望小風和小馬都能好好地支持小風媽和小馬媽，特別小風媽和小馬媽都是小風小馬最重視的人。也好期待帶小風媽和小馬媽一起去日月潭，讓小風小馬最在意的小風媽和小馬媽一起旅行，一起吃好吃的，一起看美麗的風景。

這幾年對小馬來說也變化很大，小馬最近因為接了執事而有點忙，希望過渡期之後可以恢復舒服的步調。謝謝老公一直陪在小馬身邊，雖然小馬常常空空症或濫好人讓老公生氣，謝謝老公一直包容小馬。小馬有時候會講教會例如榮芳很重要之類的，卻常常害老公誤會小風不重要，對不起小馬有時太習慣就不小心把老公當理所當然，可是老公和家人的付出對我都是最重要的。

老公準備要換新的工作，希望老公的下一站會是小風喜歡、有成就感的，小馬就可以去探班看老公開心的樣子>8< 老公是這麼認真的人，也那麼喜歡和人相處，希望上帝為老公帶來更有趣的機會。

未來日子還很多未知，可是有小風一起，小馬就有勇氣面對。小風的笑容，總是可以融化小馬，小馬想繼續讓小風開心。但願上帝可以帶小風和小馬，在小風滿38歲的這個時候，不知道小風會許什麼願望呢？小馬會繼續陪小風一起實現小風的願望，一起創造更多小風小馬>8< 親愛的老公生日快樂>8<

你的老公小馬 🐴🐤 2024/7/31`

const Finish = ({className}) => {
  return (
    <div className={cn("finish", "fadein", className)}>
      {text.split('\n').map((t, i) => <p key={i}>{t}</p>)}
    </div>
  )
};

export default Finish
